import React, { Component } from 'react';

import { BloxButton } from 'styled_components/Common/BloxButton';
import LoadingCube from 'sub_components/Common/LoadingCube';
import { DeleteStorageDataProvider } from 'context/DeleteStorageContext';
import DeleteStorageModal from 'blox_components/Storage/DeleteStorage/DeleteStorageModal';
import { STORAGE_ICONS } from 'utils/StorageConstants';
import { A1 } from 'styled_components/Storage/Icons/A1';
import LocationDisplay from './LocationDisplay';

const CDN_URL = process.env.REACT_APP_CDN_URL;

const RedundancyIcon = `${CDN_URL}storage/Storage-mirror-arrows-inactive.svg`;
const SmallPublicIcon = `${CDN_URL}storage/Storage-public-icon-gray`;
const SmallPrivateIcon = `${CDN_URL}storage/Storage-private-icon-default.svg`;

class SharesLocationComponent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selected: null,
			shares: [],
			share: null,
			buttonActive: false,
			showModal: false,
		};
	}

	goToDeleteStorage = () => {
		setTimeout(() => {
			this.toggleDeleteStorageModal();
		}, 1000);
	};
	toggleDeleteStorageModal = () => {
		const { showModal } = this.state;
		this.setState({ showModal: !showModal });
	};

	mapShare = (pending, deleted) => {
		const { share, deleteStorageAccess, locations, breakpoint } = this.props;
		const Icon = STORAGE_ICONS[share?.icon] ? STORAGE_ICONS[share?.icon] : A1;
		return (
			<div className='shares-location-container'>
				<div className='left-section'>
					<div className='top-section-container'>
						<div className='top-left-icon'>
							{share?.replication && <img src={RedundancyIcon} className='redundancy-icon' />}
						</div>
						<div className='top-right-icon'>
							{!share?.isPrivate && share && (
								<img src={SmallPublicIcon} className='small-accessibility' />
							)}
							{share?.isPrivate && share && (
								<img src={SmallPrivateIcon} className='small-accessibility' />
							)}
						</div>
						<div className='center-icon'>
							{share && <Icon color={share?.icon_color ? share?.icon_color : '#00b0b9'} />}
						</div>
						{pending && <span className='state pending labels20'>PROVISIONING</span>}
						{deleted && <span className='state deleted labels20'>DELETED</span>}
					</div>

					<div className='bottom-section'>
						{share && (
							<BloxButton
								className='buttons41'
								id='okay'
								text='DELETE'
								module='storage'
								enabled={deleteStorageAccess && share?.status !== 'deleted' ? true : false}
								onClick={this.goToDeleteStorage}
								cypressId='delete-share'
							/>
						)}
					</div>
				</div>
				<div className='right-section'>
					{share && (
						<LocationDisplay breakpoint={breakpoint} locations={locations} module={'storage'} />
					)}
				</div>
			</div>
		);
	};

	componentDidMount() {
		const { setShareName, share } = this.props;
		if (share && share?.common_name) {
			setShareName(share?.common_name);
		}
	}

	componentDidUpdate(prevProps) {
		const { share, setShareName } = this.props;
		if (share !== prevProps?.share && share?.common_name) {
			setShareName(share?.common_name);
		}
	}

	render() {
		const { share, loading, navigate, getShares, ticketType } = this.props;
		const { showModal } = this.state;
		const { breakpoint, setModalContent } = this.props;
		const deleted =
			share?.status === 'deleted' || share?.status === 'pending_delete' ? true : false;

		const pending = share?.status === 'pending' || share?.status === 'processing' ? 'deleted' : '';

		return (
			<>
				{!share && loading && <LoadingCube />}
				{!share && !loading && <div className='body10'>Error getting share details.</div>}

				<DeleteStorageDataProvider>
					<DeleteStorageModal
						breakpoint={breakpoint}
						setModalContent={setModalContent}
						closeModal={this.toggleDeleteStorageModal}
						showModal={showModal}
						share={share}
						navigate={navigate}
						getShares={getShares}
						ticketType={ticketType}
					/>
				</DeleteStorageDataProvider>

				{share && this.mapShare(pending, deleted)}
			</>
		);
	}
}

export default SharesLocationComponent;
